module.exports = __webpack_public_path__ + "static/img/RAP-SCAPC2_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAP-SCAPC2_1.png
// module id = wUz9
// module chunks = 0